function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.00165 8.33334L8.33499 3.00001C8.95382 2.38117 9.79315 2.03351 10.6683 2.03351C11.5435 2.03351 12.3828 2.38117 13.0017 3.00001C13.6205 3.61884 13.9682 4.45817 13.9682 5.33334C13.9682 6.20851 13.6205 7.04783 13.0017 7.66667L7.66832 13C7.04948 13.6188 6.21016 13.9665 5.33499 13.9665C4.45982 13.9665 3.62049 13.6188 3.00165 13C2.38282 12.3812 2.03516 11.5418 2.03516 10.6667C2.03516 9.7915 2.38282 8.95218 3.00165 8.33334Z",
  fill: "#94B4A4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.00165 8.33334L8.33499 3.00001C8.95383 2.38117 9.79315 2.03351 10.6683 2.03351C11.5435 2.03351 12.3828 2.38117 13.0017 3.00001C13.6205 3.61884 13.9682 4.45817 13.9682 5.33334C13.9682 6.20851 13.6205 7.04783 13.0017 7.66667L7.66832 13C7.04948 13.6188 6.21016 13.9665 5.33499 13.9665C4.45982 13.9665 3.62049 13.6188 3.00165 13C2.38282 12.3812 2.03516 11.5418 2.03516 10.6667C2.03516 9.7915 2.38282 8.95218 3.00165 8.33334",
  stroke: "#94B4A4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10 8V8.00833",
  stroke: "white",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6 8V8.00833",
  stroke: "white",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8 6V6.00833",
  stroke: "white",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8 10V10.0083",
  stroke: "white",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPatchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatchIcon);
export default __webpack_public_path__ + "static/media/patch-icon.35ec8a9b.svg";
export { ForwardRef as ReactComponent };